/* eslint-disable @typescript-eslint/no-unused-vars */
import { Outlet, Route, Routes } from 'react-router-dom';
import { useContext } from 'react';
import Settings from './Templates/Settings/Settings';
import MessageTemplateProvider from './Templates/Settings/Emails/MessageTemplateProvider';
import Statistics from './Templates/Statistics/Statistics';
import RecommendationRequestLoggedIn from './Templates/Recommendation/RecommendationRequestLoggedIn';
import DocumentsPage from './Organismns/Tables/DocumentsPage';
import RecommendationRequest from './Templates/Recommendation/RecommendationRequest';
import { DocumentLayoutContextProviderProxy } from './Service/Context/DocumentLayoutContext';
import PortalLayout from './Templates/Portal/PortalLayout';
import AccountSettings from './Templates/Settings/Account/AccountSettings';
import Accounting from './Templates/Settings/Accounting/Accounting';
import Bills from './Templates/Settings/Billing/Bills';
import PackageSection from './Templates/Settings/Billing/PackageSection';
import CalendarConfig from './Templates/Settings/Calendar/CalendarConfig';
import CustomFields from './Templates/Settings/CustomFields/CustomFields';
import SequentialNumbers from './Templates/Settings/Documents/SequentialNumbers';
import MailAccount from './Templates/Settings/Emails/MailAccounts';
import MessageTemplateList from './Templates/Settings/Emails/MessageTemplateList';
import SignaturePane from './Templates/Settings/Emails/SignaturePane';
import PromoMaterial from './Templates/Settings/FileUploads/PromoMaterial';
import { GDPR } from './Templates/Settings/GDPR';
import RecruitmentCampaign from './Templates/Settings/Recruitment/RecruitmentSection';
import Workflow from './Templates/Settings/Reminder/WorkflowSection';
import Team from './Templates/Settings/Team/Team';
import { ConnectWebsiteProxy } from './Templates/Settings/WebHooks/ConnectWebsite';
import Messaging from './Templates/Emails/Messaging';
import EmailInboxPage from './Templates/Emails/EmailInboxPage';
import EventDetails from './Templates/Event/EventDetails';
import EventResources from './Templates/Resource/EventResources';
import EventProfit from './Organismns/EventProfit';
import EventDocuments from './Templates/Event/EventDocuments';
import { Contracts } from './Organismns/Contract/Contracts';
import SharePane from './Organismns/Share/SharePane';
import { EmailTemplateEditorSkeleton } from './Organismns/Settings/EmailTemplateEditorSkeleton';
import EventForm from './Templates/Event/EventForm';
import DocumentSettings from './Templates/Settings/Documents/DocumentSettings';
import Tasks from './Organismns/Tasks/Tasks';
import ConfirmInvitationPage from './Templates/Security/ConfirmInvitationPage';
import TaskEditModal from './Molecules/Event/Tasks/TaskEditModal';
import TaskCreateModal from './Molecules/Event/Tasks/TaskCreateModal';
import LoginPage from './Templates/Security/LoginPage';
import RegisterPage from './Templates/Security/RegisterPage';
import AccountAccessRevokedPage from './Templates/Security/AccountAccessRevokedPage';
import BookitupTemplate from './Templates/BookitupTemplate';
import RegistrationCompleted from './Templates/Security/RegistrationCompleted';
import PasswordForgotten from './Templates/Security/PasswordForgotten';
import EmailVerificationPage from './Templates/Security/EmailVerificationPage';
import PasswordResetPage from './Templates/Security/PasswordResetPage';
import RecurringTaskModalFlow from './Templates/Settings/Reminder/RecurringTaskModalFlow';
import CustomAttributeDeleteModalFlow from './Templates/Settings/CustomFields/CustomAttributeDeleteFlow/CustomAttributeDeleteModalFlowParent';
import ShareModalFlow from './Organismns/Share/ShareFlow/ShareModalFlowParent';
import InsertPortalLink from './Organismns/Message/InsertPortalLink';
import DocumentPreview from './Molecules/Document/DocumentPreview';
import ContractPreview from './Templates/Contract/ContractPreview';
import QuestionnairePreview from './Templates/Fragebögen/QuestionnairePreview';
import { ContractTemplates } from './Templates/Settings/Documents/Contract/ContractTemplates';
import { ContactContextProvider } from './Service/Context/ContactContext';
import { ProfileContextProvider } from './Service/Context/ProfileContext';
import { ApplicationUserContextProvider } from './Service/Context/ApplicationUserContext';
import { BankAccountContextProvider } from './Service/Context/BankAccountContext';
import { AnnoucementsContextProvider } from './Service/Context/AnnouncementsContext';
import { AuthContext } from './Service/Context/AuthContext';
import LoxOAuthDispatcher from './Molecules/Lexoffice/OAuthDispatcher';
import ContactFormList from './Templates/Settings/ContactFormBuilder/ContactFormList';
import BaseTable from './Organismns/Tables/BaseTable';
import ResourcesPage from './Organismns/Resources/ResourcesPage';
import ResourcePage from './Organismns/Resources/ResourcePage';
import ResourceDetails from './Organismns/Resources/ResourceDetails';
import { NotificationsContextProvider } from './Service/Context/NotificationsContext';
import WorkflowTemplate from './Templates/Settings/Workflow/WorkflowTemplate';
import ContactsPage from './Templates/Contacts/ContactsPage';
import GoogleSection from './Templates/Settings/Google/GoogleSection';
import { EventsContextProvider } from './Service/Context/EventsContext';
import EventsPage from './Templates/EventList/EventsPage';
import AllResources from './Templates/Resource/AllResources';
import ResourcesPane from './Templates/Settings/Resources/ResourcesPane';
import ResourceStockIntervals from './Organismns/Resources/stocks/ResourceStockIntervals';
import ResoucePlannings from './Organismns/Resources/planning/ResoucePlannings';
import { EventResourcePlanningContextProvider } from './Service/Context/EventResourcePlanningContext';
import { AddonContextProvider } from './Service/Context/ResourceAddonsContext';
import { ViolationContextProvider } from './Service/Context/ViolationContext';
import { BookitupFormContextProvider } from './Service/Context/BookitupFormContext';
import ContactForm from './Templates/Settings/ContactFormBuilder/ContactForm';
import { MessageContextProvider } from './Service/Context/MessageContextV2';
import ManagementPage from './Templates/Management/ManagementPage';
import EventKinds from './Templates/Settings/EventKinds';
import EventStates from './Templates/Settings/CustomStates';
import { ICalContextProvider } from './Service/Context/ICalContext';
import AcademyChannel from './Organismns/Academy/AcademyChannel';
import AcademyPage from './Organismns/Academy/AcademyPage';
import AcademyLandingPage from './Organismns/Academy/AcademyLandingPage';
import AgencyTemplatesSection from './Templates/Settings/Emails/agency/AgencyTemplatesSection';
import AgencyTemplateEditor from './Templates/Settings/Emails/agency/AgencyTemplateEditor';
import AzureOAuthDispatcher from './Templates/Settings/Emails/oauth/AzureOAuthDispatcher';
import AwaitAccountCreatedPage from './Templates/Security/ActivateAccountAfterRedirect';
import { BookitupSubscriptionProvider } from './Service/Context/BookitupSubscriptionContext';
import { ContractTemplateContextProvider } from './Service/Context/ContractTemplateContext';
import ContractTemplate from './Molecules/Settings/ContractTemplates/ContractTemplateV2';
import { ContractContextProvider } from './Service/Context/ContractContextV2';
import Contract from './Templates/Contract/Contract';
import { DocumentContextProvider } from './Service/Context/DocumentContextV2';
import { DocumentTemplateContextProvider } from './Service/Context/DocumentTemplateContext';
import DocumentTemplateEditor from './Molecules/Settings/DocumentTemplates/DocumentTemplateEditor';
import DocumentTemplatesSection from './Templates/Settings/Documents/DocumentTemplates/DocumentTemplatesSection';
import ProductsSection from './Organismns/Settings/Documents/Positions/ProductsSection';
import { ProductsContextProvider } from './Service/Context/proxy/ProductsContext';
import DocumentEditor from './Templates/Event/DocumentEditor';
import QuestionnaireTemplateList from './Templates/Settings/QuestionnaireTemplates/QuestionnaireTemplateList';
import { QuestionnaireTemplateContextProviderV2 } from './Service/Context/QuestionnaireTemplateContext';
import QuestionnaireTemplateEditor from './Molecules/Settings/QuestionnaireTemplate/QuestionnaireTemplateEditor';
import { QuestionnaireContextProvider } from './Service/QuestionnaireContextV2';
import QuestionnaireEditor from './Templates/Fragebögen/QuestionnaireEditor';
import Taxes from './Templates/Settings/Documents/TaxesV2';
import { EventContextProvider } from './Service/Context/EventContext';
import { EventLocationProvider } from './Service/Context/EventLocationContextV2';
import { EventParticipationsProvider } from './Service/Context/EventParticipationContextV2';
import { CustomAttributesContextProvider } from './Service/Context/CustomAttributeContext';
import { EventPortalContextProvider } from './Service/Context/EventPortalContext';
import CancelSubscriptionDispatcher from './Templates/Settings/Billing/CancelSubscriptionDispatcher';
import ContactPage from './Templates/Contacts/ContactPage/ContactPage';
import { ContactDetailsProvider } from './Service/Context/ContactDetailsContext';
import ContactDetailsSection from './Templates/Contacts/ContactPage/ContactDetailsSection';
import ContactDocuments from './Templates/Contacts/ContactPage/ContactDocuments';
import { GeneralPostboxCountsProvider } from './Service/Context/GeneralPostboxCountsProvider';
import { GeneralPostboxProvider } from './Service/Context/GeneralPostboxProvider';
import EmailsSection from './Organismns/Message/EmailsSection';
import InvoicesSection from './Templates/Settings/Billing/InvoicesSection';
import { EventEmailBoxContextProvider } from './Service/Context/EventEmailBoxContextProvider';
import { ContactEmaillBoxContextProvider } from './Service/Context/ContactEmailBoxContextProvider';
import { EventPostboxCountsProvider } from './Service/Context/EventPostboxCountsProvider';

const ApplicationRoutes = () => {
  const { isAuthenticated } = useContext(AuthContext);
  return (
    <Routes>
      {/* AUTH ROUTES  */}
      {isAuthenticated && (
        <Route path="" element={<ApplicationUserContextProvider />}>
          <Route path="" element={<BookitupSubscriptionProvider />}>
            <Route path="" element={<ProfileContextProvider />}>
              <Route path="" element={<ContactContextProvider />}>
                <Route path="" element={<NotificationsContextProvider />}>
                  <Route path="" element={<AddonContextProvider />}>
                    <Route path="" element={<ViolationContextProvider />}>
                      <Route path="" element={<AnnoucementsContextProvider />}>
                        <Route path="" element={<EventsContextProvider />}>
                          <Route path="" element={<ICalContextProvider />}>
                            <Route path="" element={<EventsPage />} />
                          </Route>
                        </Route>
                      </Route>
                      <Route path="management" element={<ManagementPage />} />
                      <Route path="contacts" element={<ContactsPage />} />

                      <Route path="contacts/:id" element={<MessageContextProvider />}>
                        <Route path="" element={<ContactEmaillBoxContextProvider />}>
                          <Route path="" element={<ContactDetailsProvider />}>
                            <Route path="" element={<ContactPage />}>
                              <Route path="details" element={<ContactDetailsSection />} />
                              <Route path="documents" element={<ContactDocuments />} />
                              <Route path="emails/:box" element={<EmailsSection />} />
                            </Route>
                          </Route>
                        </Route>
                      </Route>

                      <Route path="statistics" element={<Statistics />} />
                      <Route path="recommendationRequest/:id" element={<RecommendationRequestLoggedIn />} />
                      <Route path="tasks" element={<Tasks />} />

                      <Route path="resources" element={<ResourcesPage />}>
                        <Route path="all" element={<AllResources />} />
                      </Route>
                      <Route path="resources/:id" element={<ResourcePage />}>
                        <Route path="details" element={<ResourceDetails />} />
                        <Route path="stock-intervals" element={<ResourceStockIntervals />} />
                        <Route path="planning" element={<ResoucePlannings />} />
                      </Route>

                      <Route path="documents" element={<DocumentsPage />}>
                        <Route path="" element={<BaseTable />} />
                        <Route path="" element={<DocumentContextProvider />}>
                          <Route path=":documentId" element={<DocumentEditor />} />
                          <Route path=":documentId/preview" element={<DocumentPreview />} />
                        </Route>
                      </Route>
                      <Route>
                        <Route path="postbox" element={<GeneralPostboxCountsProvider />}>
                          <Route path="" element={<MessageContextProvider />}>
                            <Route path="" element={<GeneralPostboxProvider />}>
                              <Route path="" element={<EmailInboxPage />}>
                                <Route path=":box" element={<EmailsSection />} />
                                <Route path=":box/:filter" element={<EmailsSection />} />
                              </Route>
                            </Route>
                          </Route>
                        </Route>
                      </Route>
                      <Route path="events/:id" element={<EventContextProvider />}>
                        <Route path="" element={<EventLocationProvider />}>
                          <Route path="" element={<EventParticipationsProvider />}>
                            <Route path="" element={<EventPostboxCountsProvider />}>
                              <Route path="" element={<MessageContextProvider />}>
                                <Route path="" element={<EventEmailBoxContextProvider />}>
                                  <Route path="" element={<CustomAttributesContextProvider />}>
                                    <Route path="" element={<EventPortalContextProvider />}>
                                      <Route path="" element={<EventForm />}>
                                        <Route path="details" element={<EventDetails />} />
                                        <Route path="emails/:box" element={<EmailsSection />} />
                                        <Route path="" element={<EventResourcePlanningContextProvider />}>
                                          <Route path="resources" element={<EventResources />} />
                                        </Route>
                                        <Route path="contracts" element={<Contracts />} />
                                        <Route path="finance" element={<EventProfit />} />
                                        <Route path="documents" element={<EventDocuments />} />
                                        <Route path="shares" element={<SharePane />} />
                                        <Route path="documents" element={<DocumentContextProvider />}>
                                          <Route path=":documentId" element={<DocumentEditor />} />
                                          <Route path=":documentId/preview" element={<DocumentPreview />} />
                                        </Route>
                                        <Route path="questionnaires" element={<QuestionnaireContextProvider />}>
                                          <Route path=":qid" element={<QuestionnaireEditor />} />
                                          <Route path=":qid/preview" element={<QuestionnairePreview />} />
                                        </Route>
                                        <Route path="contracts" element={<ContractContextProvider />}>
                                          <Route path=":contractId" element={<Contract />} />
                                          <Route path=":contractId/preview" element={<ContractPreview />} />
                                        </Route>
                                      </Route>
                                    </Route>
                                  </Route>
                                </Route>
                              </Route>
                            </Route>
                          </Route>
                        </Route>
                      </Route>

                      <Route path="academy" element={<AcademyPage />}>
                        <Route path="welcome" element={<AcademyLandingPage />} />
                        <Route path="channels/:channelName" element={<AcademyChannel />} />
                      </Route>

                      <Route path="lxo-auth" element={<LoxOAuthDispatcher />} />
                      <Route path="azure-oauth" element={<AzureOAuthDispatcher />} />

                      <Route path="settings" element={<Settings />}>
                        <Route path="userdata" element={<BankAccountContextProvider />} />
                        <Route path="recruitment" element={<RecruitmentCampaign />} />
                        <Route path="plans" element={<PackageSection />} />
                        <Route path="invoices" element={<InvoicesSection />} />
                        <Route path="subscription/cancel" element={<CancelSubscriptionDispatcher />} />
                        <Route path="bills" element={<Bills />} />
                        <Route path="customfields" element={<CustomFields />} />
                        <Route path="eventstates" element={<EventStates />} />
                        <Route path="eventkinds" element={<EventKinds />} />
                        <Route path="bookkeeping" element={<Accounting />} />
                        <Route path="google" element={<GoogleSection />} />
                        <Route path="resources" element={<ResourcesPane />} />
                        <Route path="workflow" element={<Workflow />} />
                        <Route path="workflow/templates/:id" element={<WorkflowTemplate />} />
                        <Route path="templates" element={<DocumentTemplatesSection />} />
                        <Route path="contracts" element={<ContractTemplates />} />
                        <Route path="questionnaires" element={<QuestionnaireTemplateList />} />
                        <Route path="" element={<DocumentLayoutContextProviderProxy />}>
                          <Route path="documents" element={<DocumentSettings />} />
                        </Route>
                        <Route path="template" element={<Outlet />}>
                          <Route path="contract" element={<ContractTemplateContextProvider />}>
                            <Route path=":templateName" element={<ContractTemplate />} />
                          </Route>
                          <Route path="questionnaire" element={<QuestionnaireTemplateContextProviderV2 />}>
                            <Route path=":templateName" element={<QuestionnaireTemplateEditor />} />
                          </Route>
                          <Route path="message" element={<MessageTemplateProvider />}>
                            <Route path=":type" element={<EmailTemplateEditorSkeleton />} />
                            <Route path=":type/:name" element={<EmailTemplateEditorSkeleton />} />
                          </Route>
                          <Route path="" element={<DocumentTemplateContextProvider />}>
                            <Route path="document/:type/:id" element={<DocumentTemplateEditor />} />
                          </Route>
                        </Route>
                        <Route path="messages" element={<MessageTemplateList />} />
                        <Route path="agency/messages" element={<AgencyTemplatesSection />} />
                        <Route path="agency/message/:id" element={<AgencyTemplateEditor />} />
                        <Route path="signature" element={<SignaturePane />} />
                        <Route path="mail-account" element={<MailAccount />} />
                        <Route path="files" element={<PromoMaterial />} />
                        <Route path="connectwebsite" element={<ConnectWebsiteProxy />} />

                        <Route path="contact-form" element={<ContactFormList />} />
                        <Route path="" element={<BookitupFormContextProvider />}>
                          <Route path="contact-form/:id" element={<ContactForm />} />
                        </Route>
                        <Route path="gdpr" element={<GDPR />} />
                        <Route path="calendar" element={<CalendarConfig />} />
                        <Route path="sequentialnumbers/" element={<SequentialNumbers />} />
                        <Route path="taxes" element={<Taxes />} />
                        <Route path="portal" element={<PortalLayout />} />
                        <Route path="team" element={<Team />} />
                        <Route path="" element={<ProductsContextProvider />}>
                          <Route path="positions" element={<ProductsSection />} />
                        </Route>
                        <Route path="account" element={<AccountSettings />} />
                      </Route>
                    </Route>
                  </Route>
                </Route>
              </Route>
            </Route>
          </Route>
        </Route>
      )}
      {/* NON AUTH ROUTES  */}
      <Route path="" element={<AnnoucementsContextProvider showSeenStories />}>
        <Route path="" element={<BookitupTemplate />}>
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/registration-completed" element={<RegistrationCompleted />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/account-access-revoked" element={<AccountAccessRevokedPage />} />
          <Route path="/password-forgotten" element={<PasswordForgotten />} />
          <Route path="/verify-email" element={<EmailVerificationPage />} />
          <Route path="/await-account-created" element={<AwaitAccountCreatedPage />} />
          <Route path="/reset-password" element={<PasswordResetPage />} />
          <Route path="/confirm-invitation" element={<ConfirmInvitationPage />} />
          <Route path="/recommendationRequest/:id" element={<RecommendationRequest />} />
        </Route>
      </Route>
    </Routes>
  );
};

export const ModalRoutes = {
  taskEditModal: TaskEditModal,
  taskCreateModal: TaskCreateModal,
  recurringTaskModalFlow: RecurringTaskModalFlow,
  customAttributeDeleteModalFlow: CustomAttributeDeleteModalFlow,
  shareModalFlow: ShareModalFlow,
  insertPortalLink: InsertPortalLink,
};

export default ApplicationRoutes;
